import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from './Student/Home/Sidebar';
import Navbar from './Student/Home/Navbar';
import InvestorSidebar from './Investor/IDashBoard/InvestorSidebar';
import InvestorHeader from './Investor/IDashBoard/InvestorHeader';
import InvestorDashboard from './Investor/IDashBoard/InvestorDashboard';
import Inprocess from './Investor/Status/Inprocess';
import Selected from './Investor/Status/Selected';
import Cancelled from './Investor/Status/Cancelled';
import MyInvestments from './Investor/Tracking/MyInvestment';
import Interested from './Investor/Interested';
import Projects from './Investor/MyInvestment/MyInvestment';


function  InvestorApp() {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };

    return (
        <div style={{ display: 'flex' }}>
            <InvestorSidebar
                isSidebarCollapsed={isSidebarCollapsed}
                toggleSidebar={toggleSidebar}
            />
            <main style={{ flexGrow: 1 }}>
                <InvestorHeader
                    isSidebarCollapsed={isSidebarCollapsed}
                    toggleSidebar={toggleSidebar}
                />
                <Routes>
                   <Route path="/" element={<InvestorDashboard />} />
                   <Route path="/Inprocess" element={<Inprocess />} />
                   <Route path="/Selected" element={<Selected />} />
                   <Route path="/Status" element={<Cancelled />} />
                   <Route path="/MyInvestment" element={<Projects />} />
                   <Route path="/Interested" element={<Interested />} />

                   {/* <Route path="/Status" element={<Status />} /> */}
                   
                </Routes>
            </main>
        </div>
    );
}

export default InvestorApp;
